import { createAsyncThunk } from '@reduxjs/toolkit'
import CommentCreateUpdateArg from './comment-create-update-arg-model'
import {
  delete_commentCreateUpdateArg,
  load_commentCreateUpdateArgs,
  store_commentCreateUpdateArg,
} from './commentCreateUpdateArg-service'

export const LoadCommentCreateUpdateArgsAsync = createAsyncThunk<any, any>(
  'composer/load/commentCreateUpdateArg',
  async (params: { uid: string }) => {
    return await load_commentCreateUpdateArgs(params)
  },
)

export const CreateCommentCreateUpdateArgAsync = createAsyncThunk<any, any>(
  'composer/create/commentCreateUpdateArg',
  async (params: CommentCreateUpdateArg) => {
    return await store_commentCreateUpdateArg(params)
  },
)

export const DeleteCommentCreateUpdateArgAsync = createAsyncThunk<any, any>(
  'composer/delete/commentCreateUpdateArg',
  async (params) => {
    return await delete_commentCreateUpdateArg(params)
  },
)
